import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records/$recordId/workspace/assets/$assetId/_drawer/details",
)({
	/** Tab body is composed by the drawer layout into Figma `Details`. */
	component: () => null,
});
